module.exports = __webpack_public_path__ + "img/konut-sigortasi.6b4c83b0.png";